import React from 'react';
import { Chip, useTheme, alpha } from '@mui/material';

interface ChipStatusProps {
  label?: string;
  status?: 'active' | 'blocked' | 'pending' | 'success' | 'error' | 'warning' | 'info';
}

const ChipStatus: React.FC<ChipStatusProps> = ({ label, status }) => {
  const theme = useTheme();

  const getStatusColors = () => {
    switch (status) {
      case 'active':
      case 'success':
        return {
          backgroundColor: alpha(theme.palette.active.main, 0.12),
          color: theme.palette.active.main,
        //   border: `1px solid ${alpha(theme.palette.active.main, 0.2)}`
        };
      case 'blocked':
      case 'error':
        return {
          backgroundColor: alpha(theme.palette.banned.main, 0.12),
          color: theme.palette.banned.main,
        //   border: `1px solid ${alpha(theme.palette.banned.main, 0.2)}`
        };
      case 'pending':
      case 'warning':
        return {
          backgroundColor: alpha(theme.palette.pending.main, 0.12),
          color: theme.palette.pending.main,
        //   border: `1px solid ${alpha(theme.palette.pending.main, 0.2)}`
        };
      case 'info':
        return {
          backgroundColor: alpha(theme.palette.primary.main, 0.1),
          color: theme.palette.primary.main,
        //   border: `1px solid ${alpha(theme.palette.inactive.main, 0.2)}`
        };
      default:
        return {
          backgroundColor: theme.palette.grey[100],
          color: theme.palette.common.black,
        //   border: `1px solid ${theme.palette.grey[300]}`
        };
    }
  };

  return (
    <Chip
      label={label}
      size="small"
      variant="filled"
      sx={{
        ...getStatusColors(),
        borderRadius: '6px',
        fontSize: '0.75rem',
        height: '24px',
        minWidth: '70px',
        flexWrap: 'wrap',
        px:'0px',
        '& .MuiChip-label': {
          px: 1.5,
          fontWeight: 500
        },
        '&:hover': {
          opacity: 0.9
        }
      }}
    />
  );
};

export default ChipStatus;